export default {
  methods: {
    $_tableMixin_changeSort(column, pagination) {
      if (pagination.sortBy === column) {
        pagination.descending = !pagination.descending
      } else {
        pagination.sortBy = column
        pagination.descending = false
      }
    },
    $_tableMixin_whichIcon(item, flag) {
      if (item.programs) {
        if (item.programs.length > 0) {
          if (flag === true) {
            return 'arrow_drop_down'
          }
          return 'arrow_drop_up'
        }
      }
      return
    }
  }
}
